import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap';
import axios from 'axios';
import Constants from '../Constants';
import { useNavigate, useLocation } from 'react-router-dom';

import wordmark from '../assets/menu-wordmark.png';

function RequestPasswordResetView() {
	const navigate = useNavigate();
	const location = useLocation();
	const prefilled_email = location.state && location.state.email ? location.state.email : '';

	const [email, setEmail] = useState(prefilled_email);
	const [error, setError] = useState('');
	const [success, setSuccess] = useState(false);

	const handleSubmit = async(e)=>{
		e.preventDefault();
		setError('');
		setSuccess(false);

		if(!email){
			setError('Email is required.');
			return;
		}

		try{
			const url = Constants.SERVER_URL + '/api/auth/request_password_reset';
			const response = await axios.post(url, { email: email });

			if(response.status === 200){
				setTimeout(()=>{ navigate('/login'); }, 2500);
				setSuccess(true);
				setEmail('');
			}else{
				setError('Unexpected response from server.');
			}
		}catch(error){
			if(error.response && error.response.data && error.response.data.message){
				setError(error.response.data.message);
			}else{
				setError('Failed to connect to server.');
			}
		}
	};

	const render_form_input = (controlId, label, type, placeholder, value, setter)=>{
		return(
			<Form.Group className="mb-3" controlId={controlId}>
				<Form.Label>{label}</Form.Label>
				<Form.Control
					type={type}
					placeholder={placeholder}
					value={value}
					onChange={(e)=>setter(e.target.value)}
					required
				/>
			</Form.Group>
		);
	};


		return (
		<Container fluid className='auth-container'>
		<Row className='auth-row'>
			<Col lg={4} md={6} sm={10} xs={11}>
			<Card className='auth-card'>
				<Card.Body className='auth-card-body'>
				
					<Row>
						<img src={wordmark} className="signin-logo"/>
							{!success &&
							<Form onSubmit={handleSubmit} className='request-password-reset-form'>
								{render_form_input('resetEmail', 'Email address', 'email', 'Enter your email', email, setEmail)}

								<div className="d-grid mt-2">
									<Button variant="primary" type="submit">Send Reset Link</Button>
								</div>
							</Form>}
					</Row>
				</Card.Body>
			</Card>
			</Col>
		</Row>
		</Container>
	);
}

export default RequestPasswordResetView;
